export default __webpack_public_path__ + "static/media/see-more.e20af0bd.svg";